/*LIBRARY*/
import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

/*COMPONENT*/
import Modal from "../../Components/common_modal/Modal";
import PROJECT_CONTROL_PANEL from "../../Components/folder_project/PROJECT_CONTROL_PANEL";
import BI_CONTROL_PANEL from "../../Components/bi_basic/BI_CONTROL_PANEL";
import CREATE_PROJECT from "../../Components/project_dashboard/CREATE_PROJECT";
import CREATE_FOLDER_PROJECT from "../../Components/folder_project/CREATE_FOLDER_PROJECT";
import CREATE_BI from "../../Components/bi_basic/CREATE_BI";
import FOLDER_NAVIGATION from "../../Components/folder_project/FOLDER_NAVIGATION";
import FOLDER_PROJECT_MODE_BOX from "../../Components/folder_project/FOLDER_PROJECT_MODE_BOX";
import FOLDER_PROJECT_MODE_LIST from "../../Components/folder_project/FOLDER_PROJECT_MODE_LIST";
import PROJECT_MODE_BOX from "../../Components/project_dashboard/PROJECT_MODE_BOX";
import PROJECT_MODE_LIST from "../../Components/project_dashboard/PROJECT_MODE_LIST";
import BI_MENU_PAGE from "../../Components/dashboard_menu/BI_MENU_PAGE";
import FORM_MENU_PAGE from "../../Components/dashboard_menu/FORM_MENU_PAGE";
import MAP_SERVICE_MENU_PAGE from "../../Components/dashboard_menu/MAP_SERVICE_MENU_PAGE";

/*REDUX*/
import { getUserPaymentList } from "../../App/actions/paymentActions";
import { getGroups } from "../../App/actions/groupActions";
import { openModal } from "../../App/actions/authActions";
import { get_folder_project_list_by_user_id } from "../../App/actions/folderProjectAction";
import { get_pinned_project_list } from "../../App/actions/projectActions";
import { get_bi_list } from "../../App/actions/biActions";
import { set_value_properties } from "../../App/actions/propertiesActions";
import { get_users_who_can_access_map_service } from "../../App/actions/map_service_actions";
import {
  activities_timeseries,
  post_activities,
} from "../../App/actions/activities";

/*PICTURE*/

/*FUNCTION*/
import get_url_query from "../../App/validation/get_url_query";

/*DATA*/
import dict from "../../Data/dict.json";
import {
  block_license_with_handler,
  is_has_license_basic_or_license_sharing,
  is_have_license_enterprise_as_member_or_owner,
  is_user_get_access_by_license_key,
} from "../../App/actions/filter_license";

/*CONST*/

const PROJECT = ({
  auth,
  map_service_reducer,
  getUserPaymentList,
  getGroups,
  get_folder_project_list_by_user_id,
  get_pinned_project_list,
  get_bi_list,
  get_users_who_can_access_map_service,
  is_user_get_access_by_license_key,
  activities_timeseries,
  block_license_with_handler,
  is_have_license_enterprise_as_member_or_owner,
  post_activities,
}) => {
  const [state, setState] = useState({
    modal_create_project: false,
    modal_create_folder: false,
    modal_create_bi: false,
    mode_page: "projects",
    mode_view: "box",
    users_who_can_access_map_service: [],
  });

  useEffect(() => {
    getUserPaymentList();
    getGroups();
    get_folder_project_list_by_user_id();
    get_pinned_project_list();
    get_bi_list();
    get_users_who_can_access_map_service();
    activities_timeseries("view");
  }, [
    getUserPaymentList,
    getGroups,
    get_folder_project_list_by_user_id,
    get_pinned_project_list,
    get_bi_list,
    get_users_who_can_access_map_service,
    activities_timeseries,
  ]);

  const toggle_create_folder = () => {
    if (is_user_get_access_by_license_key("license_basic")?.is_pass) {
      setState((prevState) => ({
        ...prevState,
        modal_create_folder: !prevState.modal_create_folder,
      }));
    } else {
      block_license_with_handler();
    }
  };

  const toggle_create_project = () => {
    if (is_user_get_access_by_license_key("license_basic")?.is_pass) {
      setState((prevState) => ({
        ...prevState,
        modal_create_project: !prevState.modal_create_project,
      }));
    } else {
      block_license_with_handler();
    }
  };

  const toggle_create_bi = () => {
    if (is_user_get_access_by_license_key("license_basic")?.is_pass) {
      setState((prevState) => ({
        ...prevState,
        modal_create_bi: !prevState.modal_create_bi,
      }));
    } else {
      block_license_with_handler();
    }
  };

  //local storage
  const language = localStorage?.language || auth.language;
  const mode_view = localStorage.getItem("mode_view") || "box";
  let menu = get_url_query("menu");
  menu = menu || "project";

  //local state
  const { modal_create_project, modal_create_folder, modal_create_bi } = state;

  //global props
  const { users_who_can_access_map_service } = map_service_reducer;
  const { badge } = auth?.user;
  const user_id = auth?.user?._id;

  //content
  let create_project_content, create_folder_content, create_bi_content;

  create_project_content = (
    <CREATE_PROJECT toggle_create_project={toggle_create_project} />
  );
  create_folder_content = (
    <CREATE_FOLDER_PROJECT toggle_create_folder={toggle_create_folder} />
  );
  create_bi_content = <CREATE_BI toggle_create_bi={toggle_create_bi} />;

  const modal_create_project_content = modal_create_project && (
    <Modal
      modalSize={"small"}
      id="modal"
      isOpen={modal_create_project}
      onClose={toggle_create_project}
      title={dict?.["Create a new project"]?.[language]}
    >
      <div className="box-body">{create_project_content}</div>
    </Modal>
  );

  const modal_create_folder_content = modal_create_folder && (
    <Modal
      modalSize={"small"}
      id="modal"
      isOpen={modal_create_folder}
      onClose={toggle_create_folder}
      title={dict?.["Create a new folder"]?.[language]}
    >
      <div className="box-body">{create_folder_content}</div>
    </Modal>
  );

  const modal_create_bi_content = modal_create_bi && (
    <Modal
      modalSize={"small"}
      id="modal"
      isOpen={modal_create_bi}
      onClose={toggle_create_bi}
      title={dict?.["Create New Business Intelligence Dashboard"]?.[language]}
    >
      <div className="box-body">{create_bi_content}</div>
    </Modal>
  );

  const content_project = (
    <>
      <PROJECT_CONTROL_PANEL
        toggle_create_project={toggle_create_project}
        toggle_create_folder={toggle_create_folder}
        toggle_create_bi={toggle_create_bi}
      />
      {mode_view === "box" ? (
        <PROJECT_MODE_BOX title="Pinned" />
      ) : (
        <PROJECT_MODE_LIST title="Pinned" />
      )}
      <FOLDER_NAVIGATION />
      {mode_view === "box" ? (
        <FOLDER_PROJECT_MODE_BOX />
      ) : (
        <FOLDER_PROJECT_MODE_LIST />
      )}
      {mode_view === "box" ? <PROJECT_MODE_BOX /> : <PROJECT_MODE_LIST />}
    </>
  );

  const dashboard_menu_array = [
    {
      name: "PROJECT",
      value: "project",
    },
    {
      name: "BUSINESS INTELLIGENCE",
      value: "bi",
    },
    {
      name: "FORM",
      value: "form",
    },
    {
      name: "MAP SERVICES",
      value: "map_service",
    },
  ]?.filter((item) => {
    if (item?.value === "map_service") {
      if (
        users_who_can_access_map_service.includes(badge) ||
        users_who_can_access_map_service.includes(user_id) ||
        is_user_get_access_by_license_key("license_basic")?.is_pass
      )
        return true; // Pengguna memiliki akses ke map_service
      return false;
    } else if (item?.value === "bi") {
      if (is_have_license_enterprise_as_member_or_owner()) return true;
      return false;
    }
    return true; // selain map_service dan bi ditampilkan
  });

  return (
    <div className="main_container">
      {modal_create_project_content}
      {modal_create_folder_content}
      {modal_create_bi_content}
      <section
        style={{
          backgroundColor: "#e4ecf1",
          position: "sticky",
          top: "60px",
          zIndex: "1",
          paddingTop: "10px",
        }}
      >
        {dashboard_menu_array.map((item, idx) => {
          return (
            <Link
              to={`/dashboard?menu=${item.value}`}
              data-mapid={`clickBI-${idx}`}
              key={idx}
              onClick={() => {
                post_activities({
                  action: "open_" + item.value,
                });
              }}
            >
              <button
                className={`button_small margin_right margin_bottom ${
                  menu === item.value ? "background_black" : "background_white"
                }`}
              >
                {item.name}
              </button>
            </Link>
          );
        })}
      </section>
      <br />
      <br />

      {menu === "project" ? (
        content_project
      ) : menu === "bi" ? (
        <>
          <BI_CONTROL_PANEL
            toggle_create_project={toggle_create_project}
            toggle_create_folder={toggle_create_folder}
            toggle_create_bi={toggle_create_bi}
          />
          <BI_MENU_PAGE />
        </>
      ) : menu === "form" ? (
        <FORM_MENU_PAGE />
      ) : menu === "map_service" ? (
        <MAP_SERVICE_MENU_PAGE />
      ) : (
        content_project
      )}
      <Helmet>
        <title>{dict?.["Dashboard"]?.[language]}</title>
        <meta name="description" content={`${dict["Dashboard"][language]}`} />
      </Helmet>
    </div>
  );
};

const mapStateToProps = (state) => ({
  payment: state.payment,
  auth: state.auth,
  project: state.project,
  properties: state.properties,
  map_service_reducer: state.map_service_reducer,
});

export default connect(mapStateToProps, {
  getUserPaymentList,
  getGroups,
  openModal,
  get_folder_project_list_by_user_id,
  get_pinned_project_list,
  get_bi_list,
  set_value_properties,
  get_users_who_can_access_map_service,
  is_has_license_basic_or_license_sharing,
  is_user_get_access_by_license_key,
  activities_timeseries,
  block_license_with_handler,
  is_have_license_enterprise_as_member_or_owner,
  post_activities,
})(PROJECT);
